import { render, staticRenderFns } from "./moreDC.vue?vue&type=template&id=f1d878bc&lang=pug&"
import script from "./moreDC.vue?vue&type=script&lang=js&"
export * from "./moreDC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports